import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const ActionButtonStyled = styled(Button)`
  text-transform: uppercase;
  margin-top: 1rem;
  letter-spacing: 0.08rem;
  max-width: 43rem;
  font-weight: 700;
`;
